module.exports = __webpack_public_path__ + "img/KTB.4d834c9e.png";